"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareNativeContractsInitialValues = exports.nativeContractsFilter = exports.nativeContractsEmptyValuesCreator = void 0;
const draft_js_utils_1 = require("@dzambalaorg/draft-js-utils");
const types_1 = require("../../../../types");
const baseEmptyValues = {
    title: "",
    description: draft_js_utils_1.emptyStateString,
    symbol: "",
};
const nativeContractsEmptyValuesCreator = profile => ({
    [types_1.ServiceType.ADMIN]: {
        ...baseEmptyValues,
    },
    [types_1.ServiceType.OFFICE]: {
        ...baseEmptyValues,
        merchantId: profile.merchantId,
    },
});
exports.nativeContractsEmptyValuesCreator = nativeContractsEmptyValuesCreator;
const nativeContractsFilter = (service) => ({ title, description, contractStatus, symbol, merchantId }) => ({
    title,
    description,
    contractStatus,
    symbol,
    merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
});
exports.nativeContractsFilter = nativeContractsFilter;
const prepareNativeContractsInitialValues = (service) => ({ id, title, description, contractStatus, symbol, merchantId }) => {
    return {
        id,
        title,
        description,
        contractStatus,
        symbol,
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepareNativeContractsInitialValues = prepareNativeContractsInitialValues;
//# sourceMappingURL=schemas.js.map